// template of list in React-Select sholuld be
// [ { label: any, value: any, [...otherProps] }, ... ]

export const defaultConfigOptions = (data) => {
  if (!data) return;

  return data;
};
